import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { Media } from "@/components/forms/schemas/media";
import { artistViewSchema } from "@/pages/artists/schemas/artist";
import { genreNestedSchema } from "@/pages/genres/schemas/genre.nested.form";

// The AutoForm/submit contract. Derived from the LENIENT read schema but
// `.strip()`ped back to strict: the read schema is
// `.passthrough()` so an unmodelled field cannot blank the page, and inheriting
// that here would put an index signature on the form type and let unknown keys
// ride into `PUT /artists/{id}`. The three enrichment-lifecycle fields are
// omitted for the same reason `genres` omits `enrichmentStatus` — only the
// enricher writes them.
export const artistEditSchema = artistViewSchema
  .omit({
    tracks: true,
    metadata: true,
    enrichment: true,
    spotifyEnrichment: true,
    enrichmentStatus: true,
    embeddingStatus: true,
    enrichmentRetryCount: true,
    relatedArtists: true,
    updatedAt: true,
    createdAt: true,
    updatedBy: true,
    createdBy: true,
    curatedFields: true,
  })
  .strip()
  .extend({
    id: z.string().superRefine(
      fieldConfig({
        inputProps: {
          disabled: true,
        },
      }),
    ),
    media: Media.superRefine(
      fieldConfig({
        fieldType: "media",
        customData: {
          collection: "Artists",
        },
      }),
    ),
    genres: z
      .array(genreNestedSchema)
      .default([])
      .superRefine(
        fieldConfig({
          fieldType: "genres",
        }),
      ),
    about: z
      .string()
      .nullish()
      .superRefine(
        fieldConfig({
          fieldType: "textarea",
        }),
      ),
  });

export type ArtistEditFormType = z.infer<typeof artistEditSchema>;
